import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { LogoEffects } from './store/logo.effects';
import { StoreModule } from '@ngrx/store';
import * as store from './store/logo.reducer';
import { SharedModule } from '../shared/shared.module';
import { LogoFeatureComponent } from './feature/logo-feature.component';
import { LogoPresenterComponent } from './presenter/logo-presenter.component';

@NgModule({
    declarations: [LogoFeatureComponent, LogoPresenterComponent],
    imports: [
        CommonModule,
        SharedModule,
        StoreModule.forFeature(store.logoesFeatureKey, store.reducer),
        EffectsModule.forFeature([LogoEffects])
    ]
})
export class LogoModule {}
